import { IStackTokens } from "@fluentui/react";
import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "../../theme/customTheme";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[4],
    paddingLeft: designTokens.spacing[3],
    paddingRight: designTokens.spacing[3],
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    overflowX: "auto",
  },
  datePicker: {
    "& .ms-Calendar-dayButton:hover": {
      backgroundColor: designTokens.accent[50],
      color: designTokens.neutral[900],
    },
    "& .ms-Calendar-dayIsToday": {
      backgroundColor: designTokens.accent[100],
      color: designTokens.neutral[900],
      fontWeight: designTokens.fontWeight.semibold,
    },
    "& .ms-Calendar-dayIsToday:hover": {
      backgroundColor: designTokens.accent[200],
      color: designTokens.neutral[900],
    },
    "& .ms-Calendar-daySelected": {
      backgroundColor: `${designTokens.accent[600]} !important`,
      color: `${designTokens.neutral.white} !important`,
      ":hover": {
        backgroundColor: `${designTokens.accent[700]} !important`,
        color: `${designTokens.neutral.white} !important`,
      },
    },
  },
  miniContainer: {
    marginTop: designTokens.spacing[4],
    backgroundColor: designTokens.neutral.white,
    ...shorthands.padding(designTokens.spacing[5]),
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    boxShadow: designTokens.shadow.sm,
  },
  controlContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    rowGap: designTokens.spacing[3],
    width: "100%",
    gap: designTokens.spacing[3],
  },
  datePickerContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    width: "100%",
  },
  customDateContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: designTokens.spacing[4],
    flexWrap: "nowrap",
    width: "100%",
    "@media (max-width: 640px)": {
      flexDirection: "column",
      alignItems: "stretch",
      flexWrap: "wrap",
    },
  },
  datePickerWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[5],
    flex: "1 1 0",
    minWidth: "0",
  },
  cardContainer: {
    display: "flex",
    gap: designTokens.spacing[4],
    width: "100%",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    boxSizing: "border-box",
  },
  card: {
    minWidth: "280px",
    maxWidth: "320px",
    flex: "1 1 280px",
    ...shorthands.padding(designTokens.spacing[4], designTokens.spacing[5]),
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    backgroundColor: designTokens.neutral.white,
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    boxShadow: designTokens.shadow.sm,
    transition: `all ${designTokens.transition.base}`,
    flexShrink: 0,
    position: "relative",
    ":hover": {
      boxShadow: designTokens.shadow.md,
      ...shorthands.borderColor(designTokens.neutral[300]),
    },
  },
  cardContent: {
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[2],
  },
  icon: {
    position: "absolute",
    right: designTokens.spacing[2],
    top: designTokens.spacing[2],
    color: designTokens.neutral[500],
    cursor: "help",
  },
  metricIcon: {
    fontSize: "20px",
    color: designTokens.accent[600],
  },
  label: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[700],
    marginBottom: designTokens.spacing[1],
  },
  loadStatisticsButton: {
    minWidth: "160px",
    marginTop: designTokens.spacing[2],
  },
  errorText: {
    color: designTokens.semantic.error,
    fontSize: designTokens.fontSize.xs,
    marginTop: designTokens.spacing[1],
  },
  selectedPeriodText: {
    marginTop: designTokens.spacing[3],
    ...shorthands.padding(designTokens.spacing[3]),
    backgroundColor: designTokens.neutral[50],
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[700],
    fontWeight: designTokens.fontWeight.medium,
    wordBreak: "break-word",
  },
  exportContainer: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[4],
  },
  divider: {
    height: "1px",
    backgroundColor: designTokens.neutral[200],
    ...shorthands.margin(designTokens.spacing[3], "0"),
    width: "100%",
  },
});

export const setGapBetweenHeadersAndDetailsList: IStackTokens = {
  childrenGap: designTokens.spacing[2],
  padding: 0,
};

// Keep these as exports for backward compatibility - will be removed after updating component
export const containerClassName = "";
export const controlContainerStyles = {};
export const cardContainerStyles = {};
export const cardStyles = {};
export const cardContentStyles = {};
export const iconStyles = {};
export const metricIconStyles = {};

// Additional style objects for inputs
export const datePickerStyles = {
  root: {
    width: "100%",
    minWidth: "0",
  },
};

export const selectStyles = {
  root: {
    width: "100%",
    minWidth: "0",
  },
};
